export default function getCookieValueByName(cookies: string, name: string) {
  const match = cookies.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : undefined;
}
